import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import Button from "../../../ui/molecules/button"
import { Banner } from "../../../ui/organisms/banner"
import { useState } from "react"
import { ListM018Customer } from "./listM018Customer"

export function M018() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Elenco M018']}
            noPaddingLat
            headerLabel="Elenco M018"
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end" style={{ justifyContent: 'end' }}>
                    <Button size={"sm"} iconPosition={"off"} variant={"solid"} label="Crea nuovo" color={"orange"}
                        disabled={!sessionState.selected.customerId}
                        onClick={() => {
                            navigate('/AddNewM018')
                        }}
                    />
                </div>
            }
        >
            <div style={{ padding: '12px 24px 0px 24px' }}>
                <div>Elenco M018</div>
                <ListM018Customer />
                
            </div>

        </Layout>
    )

}